import { Shield, Crown, GraduationCap } from "lucide-react";

export function getRoleIcon(role) {
  switch (role) {
    case "admin": return <Shield className="w-3.5 h-3.5" />;
    case "manager": return <Crown className="w-3.5 h-3.5" />;
    default: return <GraduationCap className="w-3.5 h-3.5" />;
  }
}

export function getRoleBadge(role) {
  switch (role) {
    case "admin": return "bg-purple-100 text-purple-700";
    case "manager": return "bg-[#2563EB]/10 text-[#2563EB]";
    default: return "bg-[#14B8A6]/10 text-[#14B8A6]";
  }
}

export function getScoreColor(score) {
  if (score >= 80) return "text-[#14B8A6]";
  if (score >= 60) return "text-[#F59E0B]";
  if (score > 0) return "text-red-500";
  return "text-slate-300";
}
